<ion-header>
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content>

  <bloc-header-comp [compOptions]="{'title': blocHeaderTitle, 'isBackBtn': true, url: 'profil'}"></bloc-header-comp>

  <div class="ion-content-container achats-container">
    <!-- LOADING -->
    <div *ngIf="!cerfaDone || !paymentsDone" class="evs-card-ui text-center content-center flex-column">
      <div class="wpi-100 border-radius-8 padding-8 margin-bottom-40 shimmer"></div>
      <div class="text-card">
        <div class="wpi-120 inline-block border-radius-8 padding-8 shimmer"></div>
        <span class="right-col wpi-120 border-radius-8 padding-8 shimmer"></span>
        <hr class="margin-v-40 bg-neutral-200">
        <div class="wpi-120 inline-block border-radius-8 padding-8 shimmer"></div>
        <span class="right-col wpi-120 border-radius-8 padding-8 shimmer"></span>
      </div>
      <div class="wpi-180 border-radius-4 padding-20 margin-top-20 shimmer"></div>
    </div>
    <div *ngIf="!cerfaDone || !paymentsDone" class="evs-card-ui text-center content-center flex-column">
      <div class="wpi-100 border-radius-8 padding-8 margin-bottom-40 shimmer"></div>
      <div class="text-card">
        <div class="wpi-120 inline-block border-radius-8 padding-8 shimmer"></div>
        <span class="right-col wpi-120 border-radius-8 padding-8 shimmer"></span>
      </div>
    </div>
    <!-- USER PACK -->
    <div *ngIf="cerfaDone && paymentsDone" class="evs-card-ui text-center">
      <!-- NO PAYMENTS YET -->
      <ng-container *ngIf="(creditsProvisionsHistory?.length == 0 || (!isHourOnly && !isPackCode && !isPackPermis))">
        <img [src]="'assets/2022/illustrations/pas_de_formule.svg'" alt="EnvoitureSimone">
        <h5 class="title-card">Tu n'as pas encore choisi de formule</h5>
        <button class="btn full-width" (click)="openLink('offres')">Choisir mon offre</button>
      </ng-container>
      <!-- PACKS -->
      <ng-container *ngIf="creditsProvisionsHistory?.length > 0 && (isHourOnly || isPackCode || isPackPermis)">
        <h5 class="title-card-top">Mes crédits</h5>
        <div class="modal-button small-clickable" (click)="openLink('modalAchats')">
          <div class="faq-icon"></div>
        </div>
        
        <!-- PACK CODE / PERMIS -->
        <div class="credit-stock-wrapper">
          <ng-container *ngFor="let creditStock of creditStocks">
            <ng-container *ngIf="!!creditStock.value.redirectOfferId || creditStock?.value?.quantityDetails?.total > 0">
              <div class="text-card-wrapper">
                <div class="text-card-credits">
                  <h6>{{creditStock?.value?.name}}</h6>
                  <span>
                    <span class="bold">{{creditStock?.value?.quantityDetails?.total || 0}}</span>
                    <ng-container *ngIf="creditStock?.value?.quantityDetails?.total > 1"> crédits disponibles</ng-container>
                    <ng-container *ngIf="creditStock?.value?.quantityDetails?.total <= 1"> crédit disponible</ng-container>
                  </span>
                  <p *ngIf="creditStock?.value?.subname" class="credit-subname" [ngClass]="{'automatic': creditStock.value.subname === 'Boîte automatique', 'manual': creditStock.value.subname === 'Boîte manuelle'}">{{creditStock?.value?.subname}}</p>
                </div>
                <button *ngIf="creditStock.value.redirectOfferId" class="btn light" (click)="selectOffer(creditStock.value.redirectOfferId)">Acheter</button>
              </div>
              <hr class="margin-v-12 bg-neutral-200">
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <!-- PAYMENTS LIST -->
    <ng-container *ngIf="cerfaDone && paymentsDone">
      <div class="evs-card-ui text-center">
        <h5 class="title-card-top">Historique d'achats</h5>
        <ng-container *ngIf="creditsProvisionsHistory?.length == 0">
          <p class="no-history-text">C'est ici que tu retrouveras l'historique de tes achats</p>
        </ng-container>
        <ng-container *ngIf="creditsProvisionsHistory?.length > 0">
          <div class="text-card" *ngFor="let payment of creditsProvisionsHistory; let ix = index">
            <hr *ngIf="ix > 0" class="margin-v-12 bg-neutral-200">
            <!-- NO REFUND -->
            <ng-container *ngIf="(!!payment.refunds && payment.refunds.length == 0) || !payment.refunds">
              <ng-container [ngTemplateOutlet]="paymentPriceTemplate" [ngTemplateOutletContext]="{payment: payment, noRefund: true}"></ng-container>
              <ng-container [ngTemplateOutlet]="paymentTextTemplate" [ngTemplateOutletContext]="{payment: payment, noRefund: true}"></ng-container>
              <span>{{payment.provided_at | frenchDatePipe}}</span>
              <div class="payment-scheduler" *ngIf="!!payment?.repayment_schedule && !!payment?.repayment_schedule.length > 0">
                <h6>Échéances de paiement</h6>
                <ng-container *ngFor="let due_payment of payment.repayment_schedule">
                  <div class="due-payment">
                    <p class="due-payment-text">{{due_payment.due_at | frenchDatePipe}}</p>
                    <p *ngIf="due_payment.status === 'unpaid'" class="due-payment-price">{{due_payment.amount}}</p>
                    <p *ngIf="due_payment.status === 'failed'" class="due-payment-price">Echec de paiement</p>
                    <p *ngIf="due_payment.status === 'canceled'" class="due-payment-price">Annulé</p>
                    <img *ngIf="due_payment.status === 'paid' && (!due_payment.refunds || due_payment.refunds.length === 0)" class="due-payment-picto" src="assets/2022/icons/valid-on.svg" alt="EnVoitureSimone">
                    <p *ngIf="due_payment.status === 'paid' && !!due_payment.refunds && due_payment.refunds.length > 0" class="due-payment-price">{{due_payment.refunds[0].amount / 100}}€ remboursé</p>
                  </div>
                </ng-container>
              </div>
              <ng-container [ngTemplateOutlet]="expirationTemplate" [ngTemplateOutletContext]="{payment: payment}"></ng-container>
            </ng-container>
            <!-- WITH REFUND -->
            <ng-container *ngIf="!!payment.refunds && payment.refunds.length > 0">
              <span class="bold">Remboursement: </span>
              <ng-container [ngTemplateOutlet]="paymentPriceTemplate" [ngTemplateOutletContext]="{payment: payment, noRefund: false}"></ng-container>
              <ng-container [ngTemplateOutlet]="paymentTextTemplate" [ngTemplateOutletContext]="{payment: payment, noRefund: false}"></ng-container>
              <span>Remboursé le {{payment.refunds[0].refunded_at | frenchDatePipe}}</span>
              <hr class="margin-v-12 bg-neutral-200">
              <ng-container [ngTemplateOutlet]="paymentPriceTemplate" [ngTemplateOutletContext]="{payment: payment, noRefund: true}"></ng-container>
              <ng-container [ngTemplateOutlet]="paymentTextTemplate" [ngTemplateOutletContext]="{payment: payment, noRefund: true}"></ng-container>
              <span>{{payment.provided_at | frenchDatePipe}}</span>
              <ng-container [ngTemplateOutlet]="expirationTemplate" [ngTemplateOutletContext]="{payment: payment}"></ng-container>
            </ng-container>
          </div>
        </ng-container>
        <button class="btn full-width margin-top-24" [disabled]="creditsProvisionsHistory?.length == 0" (click)="openLink('paiements')">Voir mes factures</button>
      </div>
    </ng-container>

    <ng-template #expirationTemplate let-payment="payment">
      <div class="expiration-wrapper" *ngIf="!!payment.expired_at && payment.expired_at.length === 0 && payment.remaining_credits > 0">
        <div class="recapitulation">
          <span><b>{{payment.remaining_credits}}</b> crédit<span *ngIf="payment.remaining_credits > 1">s</span> disponible<span *ngIf="payment.remaining_credits > 1">s</span></span>
        </div>
      </div>
      <div class="expiration-wrapper" *ngIf="!!payment.expired_at && payment.expired_at.length > 0 && payment.remaining_credits > 0">
        <div class="recapitulation show-cursor" (click)="toggleDetails(payment.provided_at + '-details')">
          <span><b>{{payment.remaining_credits}}</b> crédit<span *ngIf="payment.remaining_credits > 1">s</span> disponible<span *ngIf="payment.remaining_credits > 1">s</span></span>
          <div class="chevron-down"><img src="assets/svg/arrowDown.svg" alt="EnvoitureSimone"></div>
        </div>
        <div [id]="payment.provided_at + '-details'" class="expiration-details">
          <span *ngFor="let each_expired_at of payment.expired_at; let i = index">
            <br *ngIf="i > 0">
            <b>{{each_expired_at.amount}}</b>&nbsp;crédit<span *ngIf="each_expired_at.amount > 1">s</span>&nbsp;<b *ngIf="each_expired_at.credit_type === 'manual_driving'">boite manuelle</b>
            <b *ngIf="each_expired_at.credit_type === 'automatic_driving'">boite automatique</b>
            <b *ngIf="each_expired_at.credit_type === 'code_exam'">examen du code</b>
            <b *ngIf="each_expired_at.credit_type === 'driving_exam'">examen de la conduite</b>&nbsp;disponible<span *ngIf="each_expired_at.amount > 1">s</span> (expire<span *ngIf="each_expired_at.amount > 1">nt</span>&nbsp;le&nbsp;{{each_expired_at.expires_at | frenchDatePipeCustom}})
          </span>
        </div>
      </div>
    </ng-template>

    <ng-template #paymentTextTemplate let-payment="payment" let-noRefund="noRefund">
      <h6>{{payment.name}}</h6>
    </ng-template>
    
    <ng-template #paymentPriceTemplate let-payment="payment" let-noRefund="noRefund">
      <ng-container>
        <span class="price right-col">
          <ng-container *ngIf="!noRefund && !!payment.refunds && payment.refunds.length > 0">{{payment.refunds[0].amount}}</ng-container>
          <ng-container *ngIf="noRefund && !payment?.discount_price">{{payment.price}}</ng-container>
          <ng-container *ngIf="noRefund && !!payment?.discount_price"><span class="line-through" *ngIf="!!payment?.discount_price">{{payment.price}}</span> {{payment.discount_price}}</ng-container>
        </span>
      </ng-container>
    </ng-template>
  </div>

</ion-content>

<ion-footer>
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>